import { Nullable } from '@hrlogics/helper-types';

import { DEFAULT_VALUE_IF_NIL } from '@clearverify/constants';

import { type PositionEmploymentStatus } from 'src/api';
import { EMPLOYMENT_STATUS_TO_LABEL } from 'src/constants/employees';

export const getEmploymentStatusLabel = (employmentStatus: Nullable<PositionEmploymentStatus>) => {
  if (!employmentStatus) return DEFAULT_VALUE_IF_NIL;
  return EMPLOYMENT_STATUS_TO_LABEL[employmentStatus];
};
